import { NotificationBell } from '@/components/notifications/NotificationBell';
import { Button } from '@/components/ui/button';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';
import { resolveAuthRoutingState } from '@/lib/authRouting';

import { useAuthStore } from '@/stores/authStore';
import { Menu, Settings } from 'lucide-react';
import { useCallback, useState } from 'react';
import { Link } from 'react-router-dom';
import { GymSwitcher } from './GymSwitcher';
import { MobileNav } from './MobileNav';
import { RoleToggleBar } from './RoleToggleBar';

export function TopBar() {
  const [mobileNavOpen, setMobileNavOpen] = useState(false);
  const user = useAuthStore((s) => s.user);
  const profiles = useAuthStore((s) => s.profiles);
  const activeProfile = useAuthStore((s) => s.activeProfile);
  const sessionActiveRoles = useAuthStore((s) => s.sessionActiveRoles);
  // BUG-010 fix: stable callback prevents MobileNav useEffect from closing immediately
  const closeMobileNav = useCallback(() => setMobileNavOpen(false), []);
  const routing = resolveAuthRoutingState({ user, profiles, activeProfile, sessionActiveRoles });
  const homePath = routing.status === 'missing-role' ? '/' : routing.path;

  return (
    <>
      <header className="sticky top-0 z-40 flex h-16 items-center gap-4 border-b border-border bg-card/80 px-4 backdrop-blur-sm lg:px-8">
        {/* Mobile menu button */}
        <Button
          variant="ghost"
          size="icon"
          className="lg:hidden"
          onClick={() => setMobileNavOpen(true)}
        >
          <Menu className="h-5 w-5" />
          <span className="sr-only">Open menu</span>
        </Button>

        {/* Mobile logo */}
        <Link to={homePath} className="flex items-center gap-2 lg:hidden">
          <img src="/ergshoot-logo.png" alt="ErgShoot" className="h-8 w-auto" />
        </Link>

        {/* Spacer */}
        <div className="hidden flex-1 lg:block" />

        {/* Right side */}
        <TooltipProvider delayDuration={300}>
          <div className="ml-auto flex items-center gap-2">
            {/* Gym Switcher - for multiple gyms in the active portal role */}
            <GymSwitcher />

            {/* Notifications */}
            <NotificationBell />

            {/* Personal Settings */}
            <Tooltip>
              <TooltipTrigger asChild>
                <Link to="/settings">
                  <Button variant="ghost" size="icon" className="hidden lg:flex">
                    <Settings className="h-4 w-4" />
                    <span className="sr-only">Personal Settings</span>
                  </Button>
                </Link>
              </TooltipTrigger>
              <TooltipContent side="bottom">Personal Settings</TooltipContent>
            </Tooltip>

            {/* Role toggle — always shows all 5 canonical roles */}
            <RoleToggleBar />
          </div>
        </TooltipProvider>
      </header>

      {/* Mobile navigation drawer */}
      <MobileNav open={mobileNavOpen} onClose={closeMobileNav} />
    </>
  );
}
